// Check ./checkFileExist if file path need change
// Unable to import if the file path string dynamic

import { isRegisterFileExist, isPropTradingFileExist } from './checkFileExist'

function getRegisterComponent(pathName, regulator) {
  try {
    let fileName = isRegisterFileExist(regulator, pathName) ? regulator : 'Default'

    return () => ({
      component: import(`@/views/register/${pathName}/${fileName}`),
    })
  } catch (error) {
    return null
  }
}

function getPropTradingComponent(pathName, regulator) {
  let regulatorFileName = regulator.toUpperCase()
  let fileName = isPropTradingFileExist(regulatorFileName, pathName) ? regulatorFileName : 'Default'
  return () => import(`@/components/propTrading/${pathName}/${fileName}`)
}

export { getRegisterComponent, getPropTradingComponent }
